// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";

const {ccclass, property} = cc._decorator;

@ccclass
export default class OrchardGoods extends BaseComponent {

    @property({tooltip: '是否能穿过'})
    bCanCross: boolean = false;

    protected bGoodsValid = true;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {

    }

    isGoodsValid() {
        return this.bGoodsValid;
    }

    collideEffect() {

    }

    isCanaCross() {
        return this.bCanCross;
    }

    getAddWaterLen() {
        return 0;
    }

    // update (dt) {}
}
